import contentService from '../../services/contentService';
import {
  FETCH_OFFER_BY_ID_FAILURE,
  FETCH_OFFER_BY_ID_REQUEST,
  FETCH_OFFER_BY_ID_SUCCESS,
  FETCH_OFFER_CLEAN_UP,
} from '../constants/offerTypes';
import { DEFAULT_LOCALE } from '../../i18n';

const fetchOfferRequest = () => {
  return {
    type: FETCH_OFFER_BY_ID_REQUEST,
  };
};

const fetchOfferSuccess = (offer) => {
  return {
    type: FETCH_OFFER_BY_ID_SUCCESS,
    payload: offer,
  };
};

const fetchOfferFailure = (error) => {
  return {
    type: FETCH_OFFER_BY_ID_FAILURE,
    payload: error,
  };
};

export const fetchOfferCleanUp = () => {
  return {
    type: FETCH_OFFER_CLEAN_UP,
  };
};

export const fetchOffer = (slug, locale = DEFAULT_LOCALE) => {
  return async (dispatch) => {
    dispatch(fetchOfferRequest());
    try {
      const offer = await contentService.getContentBySlug(slug, locale, {
        'populate[main_image]': true,
        'populate[profile]': true,
        'populate[offer_info][populate][service]': true,
      });

      if (offer) {
        dispatch(fetchOfferSuccess(offer));
      } else {
        dispatch(fetchOfferFailure('Offer not found'));
      }
    } catch (error) {
      dispatch(fetchOfferFailure(error.message));
    }
  };
};
